// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__18vS1","title":"ClientReferral_title__2jKzY","itemText":"ClientReferral_itemText__xSjHA"};